




























































import { computed, defineComponent, PropType } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import StandardErrorText from '@front-app/components/cards/state/StandardErrorText.vue';
import { Size, Spacing } from '@front-app/components/constants';
import UserAvatar from '@front-app/components/user/avatar.vue';
import { useAsyncStatus, useStatus } from '@front-app/hooks/useAsyncStatus';
import { useUsername } from '@front-app/hooks/useTranslate';
import InviteeBadge from '@front-app/modules/group/components/admin/InviteeBadge.vue';
import { InvitationCampaignInvitee, InviteeStatus } from '@front-app/services/GroupInvitationCampaignApi/model';
import { InvitationCampaignInviteesStore } from '@front-app/store/singletons/InvitationCampaignInvitees';
import { UserAvatarStore } from '@front-app/store/singletons/User';

export default defineComponent({
	components: {
		CtaButton,
		InviteeBadge,
		SimpleCard,
		StandardErrorText,
		UserAvatar,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		campaignId: {
			type: String,
			required: true,
		},
		invitee: {
			type: Object as PropType<InvitationCampaignInvitee>,
			required: true,
		},
	},
	setup(props, ctx) {
		// Change invitee status
		const changeInviteStatusStatus = useAsyncStatus();
		const {
			isError,
			isLoading,
			isSuccess,
		} = useStatus(computed(() => changeInviteStatusStatus.status.value));

		const changeInviteStatus = async (inviteeId: string, status: InviteeStatus) => {
			await changeInviteStatusStatus.track(InvitationCampaignInviteesStore.changeInviteeStatuses(
				props.groupId,
				props.campaignId,
				{
					inviteeIds: [inviteeId],
					status,
				},
			));

			if (isSuccess.value) {
				InvitationCampaignInviteesStore.fetchInviteeCounts(
					props.groupId,
					props.campaignId,
				);
			}
		};
		// END Change invitee status

		// Util
		const getUsername = useUsername(ctx);

		const getFirstNotificationTime = (invitee: InvitationCampaignInvitee) => {
			if (invitee.firstNotificationDateTime) {
				return ctx.root.$d(new Date(invitee.firstNotificationDateTime), 'long');
			}
			return ctx.root.$t('invitation-campaign.invitees.scheduled');
		};

		const getLastNotificationTime = (invitee: InvitationCampaignInvitee) => {
			if (invitee.lastNotificationDateTime) {
				return ctx.root.$d(new Date(invitee.lastNotificationDateTime), 'long');
			}
			return ctx.root.$t('na');
		};
		// END Util

		return {
			InviteeStatus,
			// Avatars
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
			// Pause/resume invites
			isError,
			isLoading,
			changeInviteStatus,
			// Util
			getUsername,
			getFirstNotificationTime,
			getLastNotificationTime,
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
